var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "banner imagebg-container",
          staticStyle: {
            height: "350px",
            "background-image":
              "url(/res/images/group-booking/groupbooking-banner.jpg)",
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("h1", { staticClass: "big-caption" }, [
              _vm._v(_vm._s(_vm.bannerline1[_vm.getCurrentLocale]) + " "),
              _c("em", [_vm._v(_vm._s(_vm.now[_vm.getCurrentLocale]))]),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "med-caption yellow-color" }, [
              _vm._v(_vm._s(_vm.bannerline2[_vm.getCurrentLocale])),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sentSuccessful === false,
                    expression: "sentSuccessful === false",
                  },
                ],
                staticClass: "col-md-9",
                attrs: { id: "main" },
              },
              [
                _c("div", { staticClass: "container shortcode travel-ideas" }, [
                  _c("h1", { staticClass: "idea-title" }, [
                    _vm._m(0),
                    _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "sdr-box booking-section" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.welcome[_vm.getCurrentLocale]))]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.welcometext1[_vm.getCurrentLocale]),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "sdr-box booking-section" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.onSubmit($event)
                        },
                      },
                    },
                    [
                      _c("div", [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.groupbooking[_vm.getCurrentLocale]) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.request[_vm.getCurrentLocale]) + ":"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group row choose-travel" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-md-5 constant-column-2",
                              },
                              [
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "radio radio-inline",
                                      staticStyle: { "margin-left": "0px" },
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "radio",
                                          name: "choose-travel",
                                          value: "1",
                                          checked: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.outwardonly = false
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.outwardandreturnflight[
                                            _vm.getCurrentLocale
                                          ]
                                        ) +
                                          "\n                                            "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "label",
                                    { staticClass: "radio radio-inline" },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "radio",
                                          name: "choose-travel",
                                          value: "2",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.outwardonly = true
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.outwardonlyflight[
                                            _vm.getCurrentLocale
                                          ]
                                        ) +
                                          "\n                                            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_departureairport[
                                    _vm.getCurrentLocale
                                  ]
                                ) + ":*"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_departureairport,
                                  expression:
                                    "inputGroupbooking_departureairport",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_departureairport
                                    .$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_departureairport",
                                name: "inputGroupbooking_departureairport",
                                placeholder:
                                  _vm.placeholder_departureairport[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_departureairport,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_departureairport =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_departureairport.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_departureairport.$dirty &&
                            !_vm.$v.inputGroupbooking_departureairport.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_destinationairport[
                                    _vm.getCurrentLocale
                                  ]
                                ) + ":*"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.inputGroupbooking_destinationairport,
                                  expression:
                                    "inputGroupbooking_destinationairport",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_destinationairport
                                    .$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_destinationairport",
                                name: "inputGroupbooking_destinationairport",
                                placeholder:
                                  _vm.placeholder_destinationairport[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_destinationairport,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_destinationairport =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_destinationairport.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_destinationairport
                              .$dirty &&
                            !_vm.$v.inputGroupbooking_destinationairport
                              .required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_departuredate[_vm.getCurrentLocale]
                                ) + ":*"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_departuredate,
                                  expression: "inputGroupbooking_departuredate",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_departuredate.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_departuredate",
                                name: "inputGroupbooking_departuredate",
                                placeholder:
                                  _vm.placeholder_departuredate[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_departuredate,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_departuredate =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_departuredate.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_departuredate.$dirty &&
                            !_vm.$v.inputGroupbooking_departuredate.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c(
                              "label",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.outwardonly === false,
                                    expression: "outwardonly === false",
                                  },
                                ],
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.label_destinationdate[
                                      _vm.getCurrentLocale
                                    ]
                                  ) + ":*"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.outwardonly === false,
                                  expression: "outwardonly === false",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_destinationdate,
                                  expression:
                                    "inputGroupbooking_destinationdate",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_destinationdate
                                    .$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_destinationdate",
                                name: "inputGroupbooking_destinationdate",
                                placeholder:
                                  _vm.placeholder_destinationdate[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_destinationdate,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_destinationdate =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_destinationdate.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_destinationdate.$dirty &&
                            !_vm.$v.inputGroupbooking_destinationdate.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-md-5 constant-column-2",
                            },
                            [
                              _c("div", [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.label_adultschilds[
                                        _vm.getCurrentLocale
                                      ]
                                    ) + ":*"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "selector" }, [
                                  _c(
                                    "select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        id: "inputGroupbooking_adultschildscount",
                                        name: "inputGroupbooking_adultschildscount",
                                      },
                                    },
                                    _vm._l(
                                      _vm.range(10, 174),
                                      function (adultsCount) {
                                        return _c(
                                          "option",
                                          {
                                            key: adultsCount,
                                            domProps: { value: adultsCount },
                                          },
                                          [_vm._v(_vm._s(adultsCount))]
                                        )
                                      }
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.label_infants[_vm.getCurrentLocale]
                                    ) + ":*"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.inputGroupbooking_infantscount,
                                      expression:
                                        "inputGroupbooking_infantscount",
                                    },
                                  ],
                                  staticClass: "input-text full-width",
                                  class: {
                                    invalid:
                                      _vm.$v.inputGroupbooking_infantscount
                                        .$error,
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "inputGroupbooking_infantscount",
                                    name: "inputGroupbooking_infantscount",
                                    placeholder: "",
                                  },
                                  domProps: {
                                    value: _vm.inputGroupbooking_infantscount,
                                  },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.inputGroupbooking_infantscount =
                                          $event.target.value
                                      },
                                      function ($event) {
                                        _vm.$v.inputGroupbooking_infantscount.$touch()
                                      },
                                    ],
                                  },
                                }),
                                _vm._v(" "),
                                _vm.$v.inputGroupbooking_infantscount.$dirty &&
                                !_vm.$v.inputGroupbooking_infantscount.required
                                  ? _c("p", { staticClass: "errormsg" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errmsg_required[
                                            _vm.getCurrentLocale
                                          ]
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.groupdetails[_vm.getCurrentLocale]) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_groupname[_vm.getCurrentLocale]
                                ) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "input-text full-width",
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_groupname",
                                name: "inputGroupbooking_groupname",
                                placeholder:
                                  _vm.placeholder_groupname[
                                    _vm.getCurrentLocale
                                  ],
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_street[_vm.getCurrentLocale]) +
                                  ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_street,
                                  expression: "inputGroupbooking_street",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid: _vm.$v.inputGroupbooking_street.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_street",
                                name: "inputGroupbooking_street",
                                placeholder:
                                  _vm.placeholder_street[_vm.getCurrentLocale],
                              },
                              domProps: { value: _vm.inputGroupbooking_street },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_street =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_street.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_street.$dirty &&
                            !_vm.$v.inputGroupbooking_street.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_streetno[_vm.getCurrentLocale]
                                ) + ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_streetno,
                                  expression: "inputGroupbooking_streetno",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_streetno.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_streetno",
                                name: "inputGroupbooking_streetno",
                                placeholder:
                                  _vm.placeholder_streetno[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_streetno,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_streetno =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_streetno.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_streetno.$dirty &&
                            !_vm.$v.inputGroupbooking_streetno.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_zip[_vm.getCurrentLocale]) +
                                  ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_zip,
                                  expression: "inputGroupbooking_zip",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid: _vm.$v.inputGroupbooking_zip.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_zip",
                                name: "inputGroupbooking_zip",
                                placeholder:
                                  _vm.placeholder_zip[_vm.getCurrentLocale],
                              },
                              domProps: { value: _vm.inputGroupbooking_zip },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_zip =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_zip.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_zip.$dirty &&
                            !_vm.$v.inputGroupbooking_zip.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_zip.$dirty &&
                            !_vm.$v.inputGroupbooking_zip.numeric
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_numeric[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_zip.$dirty &&
                            !_vm.$v.inputGroupbooking_zip.minLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_min_plz[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_zip.$dirty &&
                            !_vm.$v.inputGroupbooking_zip.maxLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_max_plz[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_place[_vm.getCurrentLocale]) +
                                  ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_place,
                                  expression: "inputGroupbooking_place",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid: _vm.$v.inputGroupbooking_place.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_place",
                                name: "inputGroupbooking_place",
                                placeholder:
                                  _vm.placeholder_place[_vm.getCurrentLocale],
                              },
                              domProps: { value: _vm.inputGroupbooking_place },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_place =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_place.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_place.$dirty &&
                            !_vm.$v.inputGroupbooking_place.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_place.$dirty &&
                            !_vm.$v.inputGroupbooking_place.letterspaces
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_letterspaces[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_place.$dirty &&
                            !_vm.$v.inputGroupbooking_place.minLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_min_residence[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_place.$dirty &&
                            !_vm.$v.inputGroupbooking_place.maxLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_max_residence[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_country[_vm.getCurrentLocale]
                                ) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "input-text full-width",
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_country",
                                name: "inputGroupbooking_country",
                                placeholder:
                                  _vm.placeholder_country[_vm.getCurrentLocale],
                              },
                            }),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.contactfor[_vm.getCurrentLocale]) + ":"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_salutation[_vm.getCurrentLocale]
                                ) + ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "input-text full-width",
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_salutation",
                                name: "inputGroupbooking_salutation",
                                placeholder:
                                  _vm.placeholder_salutation[
                                    _vm.getCurrentLocale
                                  ],
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_firstname[_vm.getCurrentLocale]
                                ) + ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_firstname,
                                  expression: "inputGroupbooking_firstname",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_firstname.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_firstname",
                                name: "inputGroupbooking_firstname",
                                placeholder:
                                  _vm.placeholder_firstname[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_firstname,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_firstname =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_firstname.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_firstname.$dirty &&
                            !_vm.$v.inputGroupbooking_firstname.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_firstname.$dirty &&
                            !_vm.$v.inputGroupbooking_firstname.minLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_min_firstname[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_firstname.$dirty &&
                            !_vm.$v.inputGroupbooking_firstname.maxLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_max_firstname[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_firstname.$dirty &&
                            !_vm.$v.inputGroupbooking_firstname.letterspaces
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_letterspaces[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_lastname[_vm.getCurrentLocale]
                                ) + ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_lastname,
                                  expression: "inputGroupbooking_lastname",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_lastname.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_lastname",
                                name: "inputGroupbooking_lastname",
                                placeholder:
                                  _vm.placeholder_lastname[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_lastname,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_lastname =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_lastname.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_lastname.$dirty &&
                            !_vm.$v.inputGroupbooking_lastname.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_lastname.$dirty &&
                            !_vm.$v.inputGroupbooking_lastname.minLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_min_firstname[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_lastname.$dirty &&
                            !_vm.$v.inputGroupbooking_lastname.maxLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_max_firstname[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_lastname.$dirty &&
                            !_vm.$v.inputGroupbooking_lastname.letterspaces
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_letterspaces[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_phone[_vm.getCurrentLocale]) +
                                  ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_phone,
                                  expression: "inputGroupbooking_phone",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid: _vm.$v.inputGroupbooking_phone.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_phone",
                                name: "inputGroupbooking_phone",
                                placeholder:
                                  _vm.placeholder_phone[_vm.getCurrentLocale],
                              },
                              domProps: { value: _vm.inputGroupbooking_phone },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_phone =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_phone.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_phone.$dirty &&
                            !_vm.$v.inputGroupbooking_phone.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_phone.$dirty &&
                            !_vm.$v.inputGroupbooking_phone.numericspaces
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_numericspaces[
                                        _vm.getCurrentLocale
                                      ]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_phone.$dirty &&
                            !_vm.$v.inputGroupbooking_phone.minLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_min_phone[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_phone.$dirty &&
                            !_vm.$v.inputGroupbooking_phone.maxLength
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_max_phone[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_mobile[_vm.getCurrentLocale]) +
                                  ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "input-text full-width",
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_mobile",
                                name: "inputGroupbooking_mobile",
                                placeholder:
                                  _vm.placeholder_mobile[_vm.getCurrentLocale],
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_fax[_vm.getCurrentLocale]) +
                                  ":"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "input-text full-width",
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_fax",
                                name: "inputGroupbooking_fax",
                                placeholder:
                                  _vm.placeholder_fax[_vm.getCurrentLocale],
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_email[_vm.getCurrentLocale]) +
                                  ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_email,
                                  expression: "inputGroupbooking_email",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid: _vm.$v.inputGroupbooking_email.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_email",
                                name: "inputGroupbooking_email",
                                placeholder:
                                  _vm.placeholder_email[_vm.getCurrentLocale],
                              },
                              domProps: { value: _vm.inputGroupbooking_email },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_email =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_email.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_email.$dirty &&
                            !_vm.$v.inputGroupbooking_email.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$v.inputGroupbooking_email.email
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_email[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.label_emailrepeat[_vm.getCurrentLocale]
                                ) + ":*"
                              ),
                              _c("small"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.inputGroupbooking_emailrepeat,
                                  expression: "inputGroupbooking_emailrepeat",
                                },
                              ],
                              staticClass: "input-text full-width",
                              class: {
                                invalid:
                                  _vm.$v.inputGroupbooking_emailrepeat.$error,
                              },
                              attrs: {
                                type: "text",
                                id: "inputGroupbooking_emailrepeat",
                                name: "inputGroupbooking_emailrepeat",
                                placeholder:
                                  _vm.placeholder_emailrepeat[
                                    _vm.getCurrentLocale
                                  ],
                              },
                              domProps: {
                                value: _vm.inputGroupbooking_emailrepeat,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.inputGroupbooking_emailrepeat =
                                      $event.target.value
                                  },
                                  function ($event) {
                                    _vm.$v.inputGroupbooking_emailrepeat.$touch()
                                  },
                                ],
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.inputGroupbooking_emailrepeat.$dirty &&
                            !_vm.$v.inputGroupbooking_emailrepeat.required
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_required[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.$v.inputGroupbooking_emailrepeat.email
                              ? _c("p", { staticClass: "errormsg" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errmsg_email[_vm.getCurrentLocale]
                                    )
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group row" }, [
                          _c("div", { staticClass: "col-md-10" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.label_remark[_vm.getCurrentLocale])
                              ),
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              staticClass: "full-width",
                              attrs: {
                                rows: "10",
                                id: "inputGroupbooking_remark",
                                name: "inputGroupbooking_remark",
                                placeholder:
                                  _vm.placeholder_remark[_vm.getCurrentLocale],
                              },
                            }),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-5" }, [
                          !_vm.vldt_Form_Groups()
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "button btn-large uppercase full-width silver",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.send_request[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.vldt_Form_Groups()
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-large icon-check uppercase full-width",
                                  attrs: { type: "submit" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.send_request[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sentSuccessful === true,
                    expression: "sentSuccessful === true",
                  },
                ],
                staticClass: "col-sm-8 col-md-9",
                attrs: { id: "main" },
              },
              [
                _c("div", { staticClass: "container shortcode travel-ideas" }, [
                  _c("h1", { staticClass: "idea-title" }, [
                    _vm._m(1),
                    _vm._v(_vm._s(_vm.wasssentsuccesful[_vm.getCurrentLocale])),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }